module.exports = "/wp-content/themes/onnit/script/cart/dist/nmiBg-f97e5ee9.jpg";